export default "__VITE_ASSET__9irWpmIk__"